function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
import { ApolloClient, InMemoryCache } from "@apollo/client";
import { createUploadLink } from "apollo-upload-client";
import { setContext } from "@apollo/client/link/context";
//import { WebSocketLink } from "@apollo/client/link/ws";
import { split } from "@apollo/client";
import { getMainDefinition } from "@apollo/client/utilities";
import { onError } from "@apollo/client/link/error";
import { from } from "@apollo/client";
import { toast } from "react-toastify";

// Mirrors EXPORT_CALL in the backend's middleware/rateLimit.js, so what the
// client treats as an export is what the server charged to the export bucket.
// Matched by shape rather than by listing the ~37 export fields, for the same
// reason it is done that way there: exports added later are covered without
// touching this file.
var EXPORT_CALL = /\b[A-Za-z0-9]*[Ee]xport[A-Za-z0-9]*\s*\(/;

// Exports whose field name does not contain "export", so the shape match above
// cannot see them. Kept in step with NAMED_EXPORT_FIELDS in the backend's
// middleware/rateLimit.js - an entry in one without the other means the server
// charges the export budget while the client stays silent, or the reverse.
var NAMED_EXPORT_CALL = /\b(?:getEmailReport)\s*\(/;
var isExportOperation = function isExportOperation(operation) {
  var _operation$query, _operation$query$loc, _operation$query$loc$;
  var name = String((operation === null || operation === void 0 ? void 0 : operation.operationName) || "").toLowerCase();
  if (name.includes("export") || name === "getemailreport") {
    return true;
  }

  // gql documents carry their source text, which cannot lie about the field
  // being called the way operationName can.
  var body = (operation === null || operation === void 0 ? void 0 : (_operation$query = operation.query) === null || _operation$query === void 0 ? void 0 : (_operation$query$loc = _operation$query.loc) === null || _operation$query$loc === void 0 ? void 0 : (_operation$query$loc$ = _operation$query$loc.source) === null || _operation$query$loc$ === void 0 ? void 0 : _operation$query$loc$.body) || "";
  return EXPORT_CALL.test(body) || NAMED_EXPORT_CALL.test(body);
};
var errorLink = onError(function (_ref) {
  var graphQLErrors = _ref.graphQLErrors,
    networkError = _ref.networkError,
    operation = _ref.operation;
  if (graphQLErrors) {
    var _iterator = _createForOfIteratorHelper(graphQLErrors),
      _step;
    try {
      for (_iterator.s(); !(_step = _iterator.n()).done;) {
        var _err$extensions;
        var err = _step.value;
        console.log({
          err: err
        });
        if (err.message.includes("Invalid or expired token") || ((_err$extensions = err.extensions) === null || _err$extensions === void 0 ? void 0 : _err$extensions.code) === "UNAUTHENTICATED") {
          console.warn("🚫 Token expired or unauthorized");

          // Clear token
          localStorage.removeItem("token");

          // Optional: redirect user to login
          window.location.href = "/login"; // or use your router's navigation
        }
      }
    } catch (err) {
      _iterator.e(err);
    } finally {
      _iterator.f();
    }
  }

  // if (networkError) {
  //   window.location.href = "/workfolio-maintenance";
  // }

  if (networkError) {
    var _networkError$respons;
    console.error("[Network error]: ".concat(networkError));

    // The export limiter (25/hour per user) lives in the middleware, so it
    // answers 429 rather than a GraphQL error - the reason never reaches
    // error.message and every report screen would otherwise have to detect it
    // for itself. Handled here so all ~37 export fields are covered at once.
    var status = networkError.statusCode || ((_networkError$respons = networkError.response) === null || _networkError$respons === void 0 ? void 0 : _networkError$respons.status);
    if (status === 429 && isExportOperation(operation)) {
      var _networkError$result;
      // The 429 body carries the limiter's own message, so the window it names
      // stays right if the limit is retuned. A non-2xx is a network error to
      // Apollo, but the body is still readable through result.
      var serverErrors = (_networkError$result = networkError.result) === null || _networkError$result === void 0 ? void 0 : _networkError$result.errors;
      var message = serverErrors && serverErrors[0] && serverErrors[0].message || "Too many exports. Please try again later.";

      // Fixed toastId: a screen firing several export queries at once would
      // otherwise stack one identical toast per query.
      toast.error(message, {
        toastId: "export-rate-limited"
      });
    }

    // if (window.location.pathname !== "/workfolio-maintenance") {
    //   window.location.href = "/workfolio-maintenance";
    // }
  }
});
var authLink = setContext(function (_, _ref2) {
  var headers = _ref2.headers;
  // get the authentication token from local storage if it exists
  var token = localStorage.getItem("token");
  // return the headers to the context so httpLink can read them
  return {
    headers: _objectSpread(_objectSpread({}, headers), {}, {
      authorization: token || ""
    })
  };
});
var uploadLink = createUploadLink({
  // uri: "http://localhost:8080",
  uri: "https://devbackend.getworkfolio.com/"
  //  uri: "http://65.109.31.126:8080",
});
var httpLink = from([errorLink, authLink, uploadLink]);

// The split function takes three parameters:
//
// * A function that's called for each operation to execute
// * The Link to use for an operation if the function returns a "truthy" value
// * The Link to use for an operation if the function returns a "falsy" value

var splitLink = split(function (_ref3) {
  var query = _ref3.query;
  var definition = getMainDefinition(query);
  return definition.kind === "OperationDefinition";
}, httpLink // <-- now with error handling inside
);
var client = new ApolloClient({
  //
  link: splitLink,
  cache: new InMemoryCache()
});
export default client;